export { default } from './createStyles';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/styles/esm/createStyles/index.js
// module id = 375
// module chunks = 0